import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { SUBMIT_PAYMENT_SERVICE_PUBLIC_REQUEST_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpPartialSuccess, hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { SubmitPaymentRequestPayload, SubmitPaymentResult } from '../types/submitPaymentRequest.types';

export const submitPublicPaymentServiceRequest = (builder: BuilderType) =>
  builder.mutation<SubmitPaymentResult, SubmitPaymentRequestPayload>({
    query: (params) => ({
      data: params,
      isErrMsgConcatErrCode: false,
      method: 'POST',
      url: SUBMIT_PAYMENT_SERVICE_PUBLIC_REQUEST_URL,
    }),
    transformResponse: (response: GenericApiResponse<SubmitPaymentResult>) => {
      if (hasCcdpSuccess(response) || hasCcdpPartialSuccess(response)) {
        return response.Result;
      }
      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
